import { useCallback } from "react";
import { useBanner } from "../../contexts/banner.js";
function useGroupCheckbox(group) {
    const banner = useBanner();
    const { id, items, isEssential } = group;
    const { previewCheckboxActiveState, consent, activeAction } = banner;
    const isDisabled = isEssential || activeAction === "history";
    const isChecked = previewCheckboxActiveState || isEssential || !!consent[id];
    const isPartial = !isEssential && consent[id]?.length && JSON.stringify(items.map(({ id })=>id).sort()) !== JSON.stringify(consent[id].sort() || []);
    const onToggle = useCallback((checked)=>banner.updateGroupChecked(id, checked), [
        banner,
        id,
        isChecked
    ]);
    return {
        isDisabled,
        isChecked,
        isPartial,
        onToggle
    };
}
export { useGroupCheckbox };
